import { mount } from '../../../js/dom-lifecycle';

mount('.filter-checkbox', function () {
    this.addEventListener('change', () => {
        const toggle = this.nextElementSibling;
        const expanded = toggle.getAttribute('aria-expanded');
        if ((this.checked && expanded === 'false') || (!this.checked && expanded === 'true')) {
            toggle.click();
        }
    });
});

mount('.filter-field', function () {
    this.addEventListener('change', event => {
        if (event.target.classList.contains('filter-checkbox')) return;
        const checkbox = this.querySelector('.filter-checkbox');
        if (checkbox && !checkbox.checked) checkbox.checked = true;
    });
});

mount('.ea-numeric-filter', function () {
    const select = this.querySelector('select');
    const wrapper = this.querySelector('[id^="wrapper_"]');
    if (!select || !wrapper) return;
    select.addEventListener('change', () => {
        wrapper.hidden = select.value !== 'between';
    });
});
